import PropTypes from 'prop-types';
import React from 'react';

export default function GreyhoundRacingRacecardSummary(props) {

  const distanceFormat = dist => {
    if(!dist){
      return;
    }
    return dist.replace(' 0f', '').replace(' 0y', '');
  }

  const {
    distance: raceDistance,
    race_class: raceClass,
    prizes: racePrizePool
  } = props.raceSummary

  return (
    <section className='gh-racecard-summary-wrapper'>
      <ul className='gh-racecard-summary-information-wrapper'>
        { !!raceDistance &&
          <li className='gh-racecard-summary-race-distance gh-racecard-summary-always-open'>{`${distanceFormat(raceDistance)}m`}</li>
        }
        { !!raceClass &&
          <li className='gh-racecard-summary-race-class gh-racecard-summary-always-open'>{raceClass}</li>
        }
        { !!racePrizePool &&
          <li className='gh-racecard-summary-race-prizes gh-racecard-summary-always-open'>{racePrizePool}</li>
        }
      </ul>

    </section>
  );
}

GreyhoundRacingRacecardSummary.propTypes = {
  prizes: PropTypes.arrayOf(PropTypes.object),
  raceSummary: PropTypes.object
};



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/components/GreyhoundRacingRacecardSummary.js